import { createContext, useContext } from "react";
import { makeAutoObservable, observable, toJS  } from "mobx";
import { loginService } from "../services/loginService";
import { registerService } from "../services/registerService";

class HomeStore {
  constructor() {
    makeAutoObservable(this);
  }

  showRequestAccountDialog = false;
  showpasswordResetDialog = false;
  isloading = false;
  brand = {};
  departments = [];
  loadedinitdata = false;
  loginInProgress = false;

  async registerUser(data) {
    try {
      const retval = await loginService.register(data);
      return retval;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }
  async getInitialData() {
    try {
      let retval = await registerService.getBrandsAndDept();
      const { brand, departments } = toJS(retval);
      this.brand = brand;

      this.departments = departments;
      this.loadedinitdata = true;
    } catch (error) {
      throw error;
    }
  }

  async login(data) {
    try {
      this.loginInProgress = true;

      const res = await loginService.login({ ...data });

      const {
        firstName,
        id,
        lastName,
        token,
        menuId,

        lastVisitedUrl,
        isWelcomed,
        userPreference,
        userPermissions,
      } = res;

      window.sessionStorage.setItem("qrjwt", token);
      window.currentUser = {
        id,
        fullName: `${firstName} ${lastName}`,
        isWelcomed,

        lastVisitedUrl,
        userPreference,
      };

      window.sessionStorage.setItem(
        "currentUser",
        JSON.stringify(window.currentUser)
      );
      window.localStorage.setItem(
        "permissions",
        JSON.stringify(userPermissions)
      );

      return { isWelcomed, lastVisitedUrl, menuId };
    } catch (error) {
      throw error;
    }
  }
}


export default createContext(new HomeStore());

